(() => {
  'use strict';

  if (window.__productFaqAccordionBootstrapped) {
    window.ProductFaqAccordionInit?.();
    return;
  }
  window.__productFaqAccordionBootstrapped = true;

  const inited = new WeakSet();

  const closeItem = (trigger, panel) => {
    trigger.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    panel.hidden = true;
  };

  const openItem = (trigger, panel) => {
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
    panel.hidden = false;
  };

  const initRoot = (root) => {
    if (!root || inited.has(root)) return;
    inited.add(root);

    const triggers = root.querySelectorAll('[data-faq-trigger]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const panelId = trigger.getAttribute('aria-controls');
        const panel = panelId ? root.querySelector(`#${CSS.escape(panelId)}`) : null;
        if (!panel) return;

        const isOpen = trigger.classList.contains('is-open');

        triggers.forEach((otherTrigger) => {
          const otherPanelId = otherTrigger.getAttribute('aria-controls');
          const otherPanel = otherPanelId ? root.querySelector(`#${CSS.escape(otherPanelId)}`) : null;
          if (otherPanel) closeItem(otherTrigger, otherPanel);
        });

        if (!isOpen) {
          openItem(trigger, panel);
        }
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-product-faq]').forEach((root) => initRoot(root));
  };

  window.ProductFaqAccordionInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target?.querySelector?.('[data-product-faq]')) {
      initAll();
    }
  });
})();
